import { render, staticRenderFns } from "./Religions.vue?vue&type=template&id=d77915ea&scoped=true&"
import script from "./Religions.vue?vue&type=script&lang=js&"
export * from "./Religions.vue?vue&type=script&lang=js&"
import style0 from "./Religions.vue?vue&type=style&index=0&id=d77915ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77915ea",
  null
  
)

export default component.exports